<template>
  <div>
    <div class="row" v-for="colors in colorChunks" style="margin-bottom: 10px;">
      <div class="col-xs-6" v-for="color in colors">
        <div
            :style="{'background-color': color.id, height: '30px'}"
            @click="select(color.id)"
            class="text-center"
        >
          <i v-if="color.id === value" style="color: #ffffff; line-height: 30px;" class="fa fa-check"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    "name": {},
    "value": {},
    "colors": {},
    "error": {}
  },

  computed: {
    colorChunks() {
      return _.chunk(this.colors, 4);
    }
  },

  methods: {
    select(code) {
      this.$emit('input', this.value === code ? null : code);
    }
  }
}
</script>
